import styled from 'styled-components';

import { ActionInput } from '@dreryk/react-components';

export const StyledPatientSearch = styled(ActionInput)`
   width: 500px;
`;
